<template>
  <v-col cols="12" sm="3" v-if="device.isDesktop">
    <v-row v-if="selectedMenu">
      <v-col cols="12">
        <div class="card-section py-4 text-center">
          {{ $t("pages.category_menu.sentence_4") }}
        </div>
        <shift-box
          v-model="model"
          :selectedMenu="selectedMenu"
          :shiftEnable="activeShiftKey"
          class="py-3"
        ></shift-box>
      </v-col>
      <v-col
        v-for="(item, i) in selectedCategories.filter(
          (i) => i.shift === selectedShiftKey
        )"
        :key="i"
        cols="12"
        class="py-1"
        :align="!item.foods.length ? 'center' : 'start'"
      >
        <v-sheet color="#fafafa" class="px-2 py-4" style="border-radius: 8px">
          <div v-if="item.foods.length">
            <v-row
              no-gutters
              justify="space-between"
              v-for="(food, ii) in item.foods"
              :key="ii"
            >
              <v-col>
                <span class="food-box-name">
                  {{ food.quantity && food.quantity + "x" }}
                  {{ toLatin(food.name) }}
                </span>
              </v-col>
              <v-col cols="auto" v-if="!checkDisabled">
                <circle-button
                  icon="mdi-close"
                  :tooltip="$t('remove_food')"
                  size="x-small"
                  @click="$emit('remove-food', food, item, ii)"
                ></circle-button>
              </v-col>
            </v-row>
          </div>
          <v-row v-else no-gutters justify="center">
            <v-col>
              <span style="color: rgba(0, 0, 0, 0.16)" class="food-box-name">
                {{ "Izaberite " + item.category }}
              </span>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="12">
        <v-btn
          block
          color="primary"
          class="white--text"
          @click="!checkDisabled ? $emit('submit') : null"
          :disabled="hasExistingOrder && checkDisabled"
          style="position: sticky; text-transform: none"
          height="46"
        >
          <v-icon>mdi-cart-outline</v-icon>
          {{
            hasExistingOrder
              ? $t("pages.category_menu.sentence_8")
              : $t("pages.category_menu.sentence_7")
          }}
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ShiftBox from "@/components/categoryMenu/shiftBox";
import hasModel from "@/mixins/hasModel";

export default {
  name: "CategoryMenuGroupSummary",
  mixins: [hasModel],
  components: {
    ShiftBox,
  },
  props: {
    selectedMenu: {
      type: Object,
      default: null,
    },
    activeShiftKey: {
      type: String,
      default: "all",
    },
    selectedShiftKey: {
      type: String,
      default: null,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    checkDisabled: {
      type: Boolean,
      default: false,
    },
    hasExistingOrder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card-section {
  border: 1px solid #0000001a;
  background-color: rgba($primary-color, 0.05);
  border-radius: 8px 8px 0 0;
}

.food-box-name {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
